import { StyledIcon } from 'fitify-ui/src/Icon/Icon.Styled'
import type { CSSProperties } from 'react'
import { css, styled } from 'styled-components'

import { Typography } from '../../Typography'

export const StyledContainer = styled.div<{
  $width?: string
  $height?: number
  $maxWidth?: CSSProperties['maxWidth']
}>`
  display: flex;
  width: ${({ $width }) => $width || '320px'};
  max-width: ${({ $maxWidth }) => $maxWidth || '320px'};
  flex-direction: column;
  padding: 16px;
  border-radius: ${({ theme }) => theme.radius['Radius XL']}px;
  background: ${({ theme }) => theme.colors['N Surface/Primary']};
  gap: 4px;
  ${({ $height }) =>
    $height !== undefined &&
    css`
      height: ${$height}px;
    `}
`

export const StyledInfo = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  gap: 8px;
`

export const StyledTitle = styled(Typography)`
  color: ${({ theme }) => theme.colors['N Content/Primary']};
  white-space: nowrap;
`

export const StyledRatingRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`

export const StyledStarsContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 2px;

  ${StyledIcon} {
    width: 14px;
    height: 14px;
    color: ${({ theme }) => theme.colors['N Content/Primary']};
  }
`

export const StyledUserInfo = styled(Typography)`
  overflow: hidden;
  color: ${({ theme }) => theme.colors['N Content/Secondary']};
  text-overflow: ellipsis;
  white-space: nowrap;
`

export const StyledReviewText = styled(Typography)`
  color: ${({ theme }) => theme.colors['N Content/Secondary']};
`
